<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col cols="8" lg="4">
          <b-card-group>
            <b-card no-body class="p-4">
              <b-card-body>
                <b-form name="login">
                  <img class="navbar-brand-full"
                       src="/img/brand/balticovo_logo.png"
                       srcset="/img/brand/balticovo_logo@2x.png 2x, /img/brand/balticovo_logo@3x.png 3x"
                       alt="Balticovo">
                  <p v-show="!isLoginFailed" class="text-muted">
                    {{ 'login_description' | translate('auth') }}
                  </p>
                  <p v-show="isLoginFailed" class="text-danger">{{ 'failed' | translate('auth') }}</p>
                  <b-input-group class="mb-3">
                    <b-input-group-prepend>
                      <b-input-group-text><i class="icon-user"/></b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input ref="email" @keydown.enter.native="attemptLogin" v-model="email"
                                  type="text" class="form-control"
                                  :placeholder=" 'email' | translate('global') "
                                  autocomplete="username-email"/>
                  </b-input-group>
                  <b-input-group class="mb-4">
                    <b-input-group-prepend><b-input-group-text>
                      <i class="icon-lock"/></b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input @keydown.enter.native="attemptLogin" name="password" v-model="password"
                                  type="password" class="form-control"
                                  :placeholder=" 'password' | translate('global') "
                                  autocomplete="current-password" />
                  </b-input-group>
                  <b-row>
                    <b-col cols="12">
                      <b-button name="login" block variant="primary" class="px-4" @click="attemptLogin()"
                                :disabled="isLoading">{{ 'login' | translate('auth') }}</b-button>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col cols="12" class="text-right mt-2">
                      <b-link class="px-0"
                                :to="{ name: 'PasswordForgot' }">
                        {{ 'forgot_password_link' | translate('auth')}}
                      </b-link>
                    </b-col>
                  </b-row>
                </b-form>
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import AuthService from '@/services/auth';
import VuexTypes from '@/store/types/index';

const AuthTypes = VuexTypes.auth;
export default {
  mounted() {
    this.$refs.email.$el.focus();
  },
  data() {
    return {
      email: '',
      password: '',
      isLoading: false,
      isLoginFailed: false,
    };
  },
  computed: {
    ...mapGetters('Auth', [
      'user'
    ]),
    ...mapGetters('Translations', [
      'translations',
    ]),
  },
  watch: {
    user: {
      handler: function () {
        this.onUserChanged();
      },
      deep: true
    },
  },
  methods: {
    ...mapActions('Auth', [
      AuthTypes.UPDATE_TOKEN,
      AuthTypes.LOAD_USER_INFO,
    ]),
    attemptLogin() {
      this.isLoading = true;
      AuthService.login(this.email, this.password).then(({ data }) => {
        this.UPDATE_TOKEN(data['access_token']).then(() => {
          this.LOAD_USER_INFO();
        });
      }, () => {
        this.isLoginFailed = true;
        this.isLoading = false;
      });
    },
    onUserChanged() {
      this.isLoading = false;
      if (this.user) {
        const redirectPath = sessionStorage.getItem('redirectPath');
        if (redirectPath) {
          sessionStorage.removeItem('redirectPath');
          this.$router.replace({ path: redirectPath });
        } else {
          this.$router.replace({ name: 'Dashboard' });
        }
      }
    },
  }
};
</script>
